if (!customElements.get("custom-shop-the-look")) {
  class CustomShopTheLook extends HTMLElement {
    constructor() {
      super();

      this.state = {
        device: "",
        isFullScreen: false,
      };

      this.docHtml = document.querySelector("html");

      this.sectionContainer = this.querySelector(
        ".custom-shop-the-look__container"
      );

      this.buttons = this.querySelectorAll("button.shop-the-look__hot-spot");

      this.panelContainer = this.querySelector(
        ".custom-shop-the-look__panel-container"
      );
      this.closeButtons = this.querySelectorAll("button[name='close']");
      this.panels = this.querySelectorAll("div.shop-the-look__panel");
    }

    // HTML
    // HIDE HEADER
    // --hide-header-group: 1

    morphSection = (htmlEl) => {
      htmlEl.classList.add("lock");
      htmlEl.style.setProperty("--hide-header-group", "1");
      this.sectionContainer.classList.add("tw-h-screen");
      this.sectionContainer.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "start",
      });
    };

    revertSection = (htmlEl) => {
      htmlEl.classList.remove("lock");
      htmlEl.style.setProperty("--hide-header-group", "0");
      this.sectionContainer.classList.remove("tw-h-screen");
    };

    handlePanels = (e) => {
      if (e.target.ariaCurrent === "true") {
        return;
      } else {
        this.buttons.forEach((btn) => {
          if (btn.ariaCurrent === "true") {
            btn.ariaCurrent = "false";
          }
        });
        e.target.ariaCurrent = "true";
        this.panels.forEach((panel) => {
          if (panel.ariaCurrent === "true") {
            panel.ariaCurrent = "false";
            panel.classList.remove("tw-flex");
            panel.classList.add("tw-hidden");
          }
          if (panel.dataset.index === e.target.dataset.index) {
            panel.ariaCurrent = "true";
            panel.classList.remove("tw-hidden");
            panel.classList.add("tw-flex");
          }
        });
      }
    };

    handleButtonClick = (e) => {
      e.preventDefault();

      // CHECKING TO SEE IF WE ARE MOBILE
      if (this.state.device === "mobile") {
        console.log("WE ARE ON MOBILE");
        this.morphSection(this.docHtml);
        this.panelContainer.classList.replace("tw-hidden", "tw-block");
        this.handlePanels(e);
      } else if (this.state.device === "desktop") {
        console.log("WE ARE ON DESKTOP");
        this.handlePanels(e);
      } else {
        return;
      }
    };

    handlePanelClose = (e) => {
      e.preventDefault();

      this.revertSection(this.docHtml);
      this.panelContainer.classList.replace("tw-block", "tw-hidden");
    };

    deviceObserver = () => {
      const mql = window.matchMedia("(max-width: 1023px)");

      this.state.device = mql.matches ? "mobile" : "desktop";

      mql.onchange = (e) => {
        if (e.matches) {
          this.state.device = "mobile";
        } else {
          this.state.device = "desktop";
        }

        console.log("onchange - this.state.device: ", this.state.device);
      };

      console.log("mount - this.state.device: ", this.state.device);
    };

    connectedCallback() {
      console.log("CustomShopTheLook connectedCallback()");
      console.log("buttons: ", this.buttons);
      console.log("panels: ", this.panels);

      this.buttons.forEach((btn) =>
        btn.addEventListener("click", this.handleButtonClick.bind(this), false)
      );

      this.closeButtons.forEach((btn) => {
        btn.addEventListener("click", this.handlePanelClose.bind(this), false);
      });

      this.deviceObserver();
    }
    disconnectedCallback() {
      this.buttons.forEach((btn) =>
        btn.removeEventListener(
          "click",
          this.handleButtonClick.bind(this),
          false
        )
      );

      this.closeButtons.forEach((btn) => {
        btn.removeEventListener(
          "click",
          this.handlePanelClose.bind(this),
          false
        );
      });
    }
  }

  customElements.define("custom-shop-the-look", CustomShopTheLook);
}
